import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['link', 'content'];

  async toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    let transcript = `<p><em>Transcript is not currently available.</em></p>`;

    if (this.hasLinkTarget && this.hasContentTarget) { // We need both targets for Transcripts to work correctly
      if (!this.#isExpanded(this.linkTarget) && (!this.contentTarget.innerHTML || this.contentTarget.innerHTML.includes(transcript))) {
        try {
          const response = await fetch(this.linkTarget.href);
          if (response.ok) {
            transcript = await response.text();
          }
        } catch (error) {
          // TypeError: Failed to fetch
          console.error(error);
        }

        this.contentTarget.innerHTML = transcript; // We trust this content is from our server
      }

      this.toggleExpanded(this.linkTarget);
    }
  }

  toggleExpanded(el) {
    if (this.#isExpanded(el)) {
      el.setAttribute('aria-expanded', 'false');
    } else {
      el.setAttribute('aria-expanded', 'true');
    }
  }

  #isExpanded(el) {
    return el.getAttribute('aria-expanded') === 'true';
  }
}
